<script>
  import AddDistance from "./AddDistance.svelte";
  import Complete from "./Complete.svelte";
  import ConfirmDistance from "./ConfirmDistance.svelte";
  import { userDistanceListener } from "./utils";

  let userHasSubmittedDistance;
  let userDistanceKey;
  let hasLoadedUserInfo = false;

  userDistanceListener(distanceKey => {
    userHasSubmittedDistance = !!distanceKey;
    userDistanceKey = distanceKey;
    hasLoadedUserInfo = true;
  });

  let component;
  let props = {};
  let distanceOptionIdx = 0;
  let carouselSlideIdx = 0;
  let showNewDistanceMessage;

  $: carouselSlideIdx = userHasSubmittedDistance ? 2 : 0;

  const steps = [
    directionForward => {
      component = AddDistance;
      props = {
        next: idx => {
          distanceOptionIdx = idx;
          carouselSlideIdx = 1;
        },
        directionForward,
        distanceOptionIdx
      };
    },
    () => {
      component = ConfirmDistance;
      props = {
        userDistanceKey,
        distanceOptionIdx,
        next: () => {
          showNewDistanceMessage = true;
          carouselSlideIdx = 2;
        },
        previous: () => {
          carouselSlideIdx = 0;
        }
      };
    },
    () => {
      component = Complete;
      props = {
        previous: () => {
          carouselSlideIdx = 0;
        },
        showNewDistanceMessage
      };
    }
  ];

  $: carouselSlideIdx, steps[carouselSlideIdx]();
</script>

<style>
  .wrapper {
    display: grid;
    padding: 2rem 0;
    overflow: hidden;
  }

  .component-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media screen and (min-width: 640px) {
    .wrapper {
      padding: 3rem 0;
    }
  }
</style>

{#if hasLoadedUserInfo}
  <div class="wrapper">
    <div class="component-wrapper">
      <svelte:component this={component} {...props} />
    </div>
  </div>
{/if}
